import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://taskflowapi.webseller.in/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth services
export const authService = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data)
};

// User services
export const userService = {
  getUsers: () => api.get('/users'),
  getUser: (id) => api.get(`/users/${id}`),
  createUser: (data) => api.post('/users', data),
  updateUser: (id, data) => api.put(`/users/${id}`, data),
  deleteUser: (id) => api.delete(`/users/${id}`)
};

// Client services
export const clientService = {
  getClients: () => api.get('/clients'),
  getClient: (id) => api.get(`/clients/${id}`),
  createClient: (data) => api.post('/clients', data),
  updateClient: (id, data) => api.put(`/clients/${id}`, data),
  deleteClient: (id) => api.delete(`/clients/${id}`)
};

// Task services
export const taskService = {
  getTasks: (params) => api.get('/tasks', { params }),
  getTask: (id) => api.get(`/tasks/${id}`),
  createTask: (data) => api.post('/tasks', data),
  updateTask: (id, data) => api.put(`/tasks/${id}`, data),
  deleteTask: (id) => api.delete(`/tasks/${id}`),
  addComment: (id, data) => api.post(`/tasks/${id}/comments`, data)
};

// Dashboard services
export const dashboardService = {
  getCompanyStats: () => api.get('/dashboard/company'),
  getEmployeeStats: () => api.get('/dashboard/employee')
};

// Admin services
export const adminService = {
  getTasks: () => api.get('/admin/tasks'),
  getTask: (id) => api.get(`/admin/tasks/${id}`),
  createTask: (data) => api.post('/admin/tasks', data),
  updateTask: (id, data) => api.put(`/admin/tasks/${id}`, data),
  deleteTask: (id) => api.delete(`/admin/tasks/${id}`),
  getDashboardStats: () => api.get('/admin/dashboard'),
  // Team management
  getTeamMembers: () => api.get('/users'),
  updateUserRole: (id, data) => api.put(`/users/${id}`, data),
  // Client management
  getClients: () => api.get('/clients'),
  updateClientStatus: (id, data) => api.put(`/clients/${id}`, data),
  // Project management
  getProjects: () => api.get('/projects'),
  getProject: (id) => api.get(`/projects/${id}`),
  createProject: (data) => api.post('/projects', data),
  updateProject: (id, data) => api.put(`/projects/${id}`, data),
  deleteProject: (id) => api.delete(`/projects/${id}`),
  getProjectTasks: (id) => api.get(`/projects/${id}/tasks`)
};

// Manager services
export const managerService = {
  getTasks: () => api.get('/manager/tasks'),
  getTask: (id) => api.get(`/manager/tasks/${id}`),
  createTask: (data) => api.post('/manager/tasks', data),
  updateTask: (id, data) => api.put(`/manager/tasks/${id}`, data),
  getDashboardStats: () => api.get('/manager/dashboard')
};

// Employee services
export const employeeService = {
  getTasks: () => api.get('/employee/tasks'),
  getTask: (id) => api.get(`/employee/tasks/${id}`),
  updateTaskStatus: (id, data) => api.put(`/employee/tasks/${id}/status`, data),
  addComment: (id, data) => api.post(`/employee/tasks/${id}/comments`, data),
  getDashboardStats: () => api.get('/employee/dashboard')
};

export default api;